module.exports = __webpack_public_path__ + "static/DisabledBaggageDelay-0fa159cb5529af5ce3b43259cff09f87.png";